import { render, staticRenderFns } from "./PipiPupuMultiFile.vue?vue&type=template&id=3f1026a2"
import script from "./PipiPupuMultiFile.vue?vue&type=script&lang=js"
export * from "./PipiPupuMultiFile.vue?vue&type=script&lang=js"
import style0 from "./PipiPupuMultiFile.vue?vue&type=style&index=0&id=3f1026a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports